import { useHideOnboardingConfirmationModal } from "@/react/components/Modals/HideOnboardingConfirmationModal";
import { useChecklistAvailable } from "@/react/hooks/useChecklistAvailable";

export const usePlatformMenuV3 = () => {
  const { isChecklistAvailable } = useChecklistAvailable();

  const shouldShowOnboarding = isChecklistAvailable;
  const hideOnboardingModal = useHideOnboardingConfirmationModal();

  return {
    shouldShowOnboarding,
    hideOnboardingModal,
  };
};
